import { render, staticRenderFns } from "./StreamRules.vue?vue&type=template&id=1cb4c654&"
import script from "./StreamRules.vue?vue&type=script&lang=js&"
export * from "./StreamRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports